import React, { Suspense } from "react";
import { FloatingContactUsButton } from "../FloatingContactUsButton/FloatingContactUsButton";
import { LoadingLogo } from "../LoadingLogo/LoadingLogo";
import { PrivacyAdvice } from "../PrivacyAdvice/PrivacyAdvice";

interface Props {
  children: React.ReactNode;
}

const Header = React.lazy(() => import("../Header/Header"));
const Footer = React.lazy(() => import("../Footer/Footer"));

export const Wrapper = ({ children }: Props) => {
  return (
    <>
      <FloatingContactUsButton />
      <main className="Layout__container">
        <Suspense fallback={<LoadingLogo />}>
          <Header />
          <div className="Layout__sections">{children}</div>
          <PrivacyAdvice />
          <Footer />
        </Suspense>
      </main>
    </>
  );
};
